module.exports = __webpack_public_path__ + "static/media/paper-matching.a422cb25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/paper-matching.svg
// module id = 863
// module chunks = 70